import CardService from "../components/Servises/CardService";
import { ServicesList } from "../constants/services";
import { useInView } from "react-intersection-observer";
import Info from "../components/Title/Info";
import Team from "../components/Title/Team";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from "react-router-dom";
import Feedback from "../components/Title/Feedback";

export default function ServisesPage() {
    const navigate = useNavigate();
    return (
        <>
            <Info />
            <div className="relative w-full bg-white">
                {/* <img src="/title/line.webp" alt="" className="lg:mt-14 w-[45%] h-1.5 lg:h-2 lg:w-2/5" /> */}
                {/* Фоновое изображение */}
                {/* <img
                    src="/title/line-card.webp"
                    alt=""
                    className="absolute left-0 top-[6%] lg:top-[6%] w-3/5 lg:w-3/5"
                />
                <img
                    src="/title/footer.webp"
                    alt="right-footer"
                    className="absolute right-0 bottom-[30%] lg:bottom-0 object-cover transform scale-x-[-1] scale-y-[-1] w-3/5 lg:w-2/5"
                    style={{ zIndex: 0 }}
                /> */}
                <div className="w-[94%] lg:w-[80%] mx-auto relative">
                    <h1 className="text-[27px] lg:text-[42px] 2xl:text-[50px] text-[#273167] font-bold mt-4 2xl:mt-7">Деятельность компании</h1>
                    <div className="w-[100%] mx-auto flex justify-end mt-2 mb-4 lg:mb-7 2xl:mb-8 z-50">
                        <button
                            onClick={() => navigate('products')} // Возвращаемся на предыдущую страницу
                            className="px-1.5 py-2 lg:px-3 2xl:px-4 lg:py-2 2xl:py-2.5 flex items-center gap-0.5 lg:gap-4 bg-[#37479F] hover:bg-[#2F3E8B] text-sm lg:text-2xl font-play font-medium lg:font-bold 2xl:text-3xl text-white rounded-[5px] lg:rounded-[8px] transition-all duration-300 hover:shadow-md"
                        >
                            Смотреть проекты
                            <ChevronRightIcon sx={{
                                fontSize: {
                                    xs: '1.3rem',
                                    lg: '2.5rem',
                                    xl: '3.0rem',
                                }
                            }} />
                        </button>
                    </div>
                    <div className="w-[100%] mx-auto grid grid-cols-2  sm:grid-cols-3 gap-3 lg:gap-y-5 lg:gap-x-[2%] 2xl:gap-y-7 2xl:gap-x-[2%] mt-4 lg:mt-8 2xl:mt-12 mb-5 lg:mb-6 2xl:mb-8 relative">
                        {ServicesList.map((card, index) => (
                            <AnimatedCard
                                key={index}
                                srcImage={card.srcImage}
                                title={card.title}
                                text={card.text}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <Team />
            <Feedback />
        </>
    );
}

interface CardServiceProps {
    srcImage: string;
    title: string;
    text: string;
}

function AnimatedCard({ srcImage, title, text }: CardServiceProps) {
    const { ref, inView } = useInView({
        triggerOnce: true, // Анимация срабатывает только один раз
        threshold: 0.7, // Срабатывание анимации, когда 70% элемента видно
    });

    return (
        <div
            ref={ref}
            className={`transition-all duration-[1500ms] ${inView ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-16"
                }`}
        >
            <CardService
                srcImage={srcImage}
                title={title}
                text={text}
            />
        </div>
    );
}